module.exports = __webpack_public_path__ + "media/newstyle/images/info-4aebcf0662b1edbd383eb1c86b451241.svg";